import { DotLegalHeader, DotLegalInfoDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { Box } from "@mui/material";
import { Trans } from "react-i18next";
import useSendReminderDialogHooks from "./SendReminderDialog.hooks";
import React from "react";
import HighlightedName from "@common/components/HighlightedName";

export interface ISendReminderDialog {
    auditId: string;
    questionnaireName: string;
    contactName: string;
    onCloseDialog: () => void;
    onReminderSent: () => void;
}

function SendReminderDialog(props: ISendReminderDialog) {
    const { translateString } = useTranslation();
    const { sendReminder, isSending, additionalMessage, setAdditionalMessage } = useSendReminderDialogHooks(props);

    return (
        <DotLegalInfoDialog
            header={translateString("sendReminder")}
            btnText={translateString("send")}
            content={
                <>
                    <Trans
                        i18nKey={"sendInternalAssessmentReminder"}
                        values={{
                            audit: props.questionnaireName,
                            respondent: props.contactName,
                        }}
                        components={{
                            strong: <HighlightedName />,
                            box: <HighlightedName />,
                        }}
                    />

                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <DotLegalHeader marginTop={2} headerStyle={"small"} center marginBottom={1.5} fontWeight={400}>
                            {translateString("addAdditionMessageToManualAuditReminder")}
                        </DotLegalHeader>
                    </Box>
                    <DotLegalTextField
                        noMargin
                        label={translateString("freeTextField")}
                        value={additionalMessage ?? null}
                        onChange={setAdditionalMessage}
                        debounce={false}
                        multiline
                        rows={3}
                    />
                </>
            }
            onCloseDialog={props.onCloseDialog}
            onBtnClick={() => sendReminder()}
            inProgress={isSending}
        />
    );
}

export default SendReminderDialog;
